import { Outlet, createFileRoute } from '@tanstack/react-router';
import { PublicLayout } from '@/components/layout/PublicLayout';

function PublicLayoutRoute() {
  return (
    <PublicLayout>
      <Outlet />
    </PublicLayout>
  );
}

export const Route = createFileRoute('/_public')({
  component: PublicLayoutRoute,
});
